var exports = {
  "wM": "workflowNavItem__qTfNWr",
  "c0": "NavList__Ly06qr",
  "Tr": "workflowNavItemMenu__AWN2xx",
  "MO": "menuOpen__6auJdx",
  "oP": "workflowIconContainer__c45wez",
  "LK": "workflowDot__nNtsV0",
  "Fd": "workflowDotOutline__vvloVY",
  "BT": "enableableWorkflowNavItem__mX7UFO",
  "w4": "userWorkflowIcon__d6offQ",
  "QO": "enabledWorkflowIcon__bOvSqv",
  "Js": "validDisabledWorkflowIcon__RYsPP5",
  "Hm": "activeWorkflowIcon__iWVU9N",
  "YH": "invalidWorkflowIcon__Fon69X",
  "_M": "userWorkflowName__LzVX2v",
  "WZ": "previewBadge__6M3LVk",
};

module.exports = exports;
